/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {FixMissingInstrumentLinkRequest} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/internal/FixMissingInstrumentLink.pb'
import {FixMissingInstrumentLinkResponse} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/internal/FixMissingInstrumentLink.pb'


export const fixMissingInstrumentLink = (request: FixMissingInstrumentLinkRequest, options?: CashRequestOptions) => post<FixMissingInstrumentLinkRequest, FixMissingInstrumentLinkResponse>("/2.0/cash/fix-missing-instrument-link", request, {...options, rejectOnError: true })